import React from "react";
import Popup from "src/components/popup/Popup";
import AccessControlForm from "../Form/AccessControlForm/AccessControlForm";

const AccessControlPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
  parentRoute,
  parentRouteId,
}) => {
  return (
    <Popup
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "1200px", // Set your width here
          },
        },
      }}
      title={!recordForEdit ? "Create Access Control" : "Edit Access Control"}
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
    >
      <AccessControlForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        parentRoute={parentRoute}
        parentRouteId={parentRouteId}
        errorsForm={errorsForm}
      />
    </Popup>
  );
};

export default AccessControlPopup;
